 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-08270d64":"759e03c7","chunk-0b5083c9":"e569591a","chunk-0e3ada36":"4f876570","chunk-109f4ac8":"25a16348","chunk-124253f6":"7adb2847","chunk-1abd2a85":"e0747953","chunk-1c8776c6":"5b28dcf1","chunk-2d216214":"f66ae056","chunk-48fc8d29":"d4b26b10","chunk-4adfc2cb":"80970e89","chunk-4ee193ba":"b80a2765","chunk-5c354cbe":"1dc36f89","chunk-6476a80f":"b43b2127","chunk-66499f86":"6fb2296e","chunk-6f8dca74":"ab6c6326","chunk-7e4eac9a":"103ea814","chunk-90fb105e":"d522a6e0","chunk-955104b2":"26a475d6","chunk-dbb8d16a":"3af3c8b7","chunk-0891119c":"16feb8fe","chunk-51c35f17":"1672b160","chunk-2d0c5046":"fbc95503","chunk-165170c0":"e387514c","chunk-308a9a57":"1d183457","chunk-31129060":"48e54e52","chunk-110c7462":"bf6100d6","chunk-54441e99":"62691ee1","chunk-582f162e":"6ceebc38","chunk-5a4deb79":"90e1c4d6","chunk-5e70a546":"6e1ff049","chunk-8707e908":"6f5ffa85","chunk-8f516e26":"b74f4bbf","chunk-a5c1f194":"0dc1c6aa","chunk-0e7753bf":"3f23a3c7","chunk-1f832b0f":"f784da1f","chunk-a7543ca6":"449636dd","chunk-c3c8c8bc":"4120101a","chunk-d7a826f4":"9dc71e8a","chunk-711a83b6":"1b699710","chunk-f3f79a2a":"d0e20939","chunk-bd23fad0":"2dff7cf5","chunk-3377a62a":"fcd8b3e5","chunk-2d0bdd64":"531d3d17","chunk-4e24537e":"6012e23a","chunk-3b57d365":"ada25cb0","chunk-361c9c0a":"3e57897f","chunk-67355449":"2d636155","chunk-9332d9aa":"f23e18e8","chunk-9475d680":"816bf61e","chunk-a74b9602":"c0af5fcb","chunk-dc51ebe2":"c1e5d450","chunk-e58aaa66":"69763390","chunk-fdd8e336":"52635913","chunk-06da49da":"5e262bcf","chunk-1e90db16":"35e318a1","chunk-493027cc":"e4f43da3","chunk-cf67f430":"ee7fc933","chunk-052f9ba4":"5577a87d","chunk-7aa3c928":"01bb980a","chunk-2457ad77":"5d9ef128"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-08270d64":1,"chunk-0b5083c9":1,"chunk-0e3ada36":1,"chunk-109f4ac8":1,"chunk-124253f6":1,"chunk-1abd2a85":1,"chunk-1c8776c6":1,"chunk-4adfc2cb":1,"chunk-4ee193ba":1,"chunk-5c354cbe":1,"chunk-6476a80f":1,"chunk-66499f86":1,"chunk-6f8dca74":1,"chunk-7e4eac9a":1,"chunk-90fb105e":1,"chunk-955104b2":1,"chunk-0891119c":1,"chunk-51c35f17":1,"chunk-165170c0":1,"chunk-308a9a57":1,"chunk-31129060":1,"chunk-110c7462":1,"chunk-54441e99":1,"chunk-582f162e":1,"chunk-5a4deb79":1,"chunk-5e70a546":1,"chunk-8707e908":1,"chunk-8f516e26":1,"chunk-a5c1f194":1,"chunk-0e7753bf":1,"chunk-1f832b0f":1,"chunk-a7543ca6":1,"chunk-c3c8c8bc":1,"chunk-d7a826f4":1,"chunk-711a83b6":1,"chunk-f3f79a2a":1,"chunk-bd23fad0":1,"chunk-3377a62a":1,"chunk-4e24537e":1,"chunk-3b57d365":1,"chunk-361c9c0a":1,"chunk-67355449":1,"chunk-9332d9aa":1,"chunk-9475d680":1,"chunk-a74b9602":1,"chunk-dc51ebe2":1,"chunk-e58aaa66":1,"chunk-fdd8e336":1,"chunk-06da49da":1,"chunk-1e90db16":1,"chunk-493027cc":1,"chunk-cf67f430":1,"chunk-052f9ba4":1,"chunk-7aa3c928":1,"chunk-2457ad77":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-08270d64":"e2326db4","chunk-0b5083c9":"f314ea4b","chunk-0e3ada36":"bf725567","chunk-109f4ac8":"235a414a","chunk-124253f6":"dfa3f236","chunk-1abd2a85":"6c493be7","chunk-1c8776c6":"609fd299","chunk-2d216214":"31d6cfe0","chunk-48fc8d29":"31d6cfe0","chunk-4adfc2cb":"b3f098da","chunk-4ee193ba":"25e2b138","chunk-5c354cbe":"ae6596c7","chunk-6476a80f":"451321d3","chunk-66499f86":"63146629","chunk-6f8dca74":"26b73869","chunk-7e4eac9a":"f7873579","chunk-90fb105e":"b5d184fb","chunk-955104b2":"47bf48ca","chunk-dbb8d16a":"31d6cfe0","chunk-0891119c":"74074422","chunk-51c35f17":"3371d386","chunk-2d0c5046":"31d6cfe0","chunk-165170c0":"19c84775","chunk-308a9a57":"ce132bf5","chunk-31129060":"1abf2752","chunk-110c7462":"9fd7105e","chunk-54441e99":"64d2e439","chunk-582f162e":"a7046c0b","chunk-5a4deb79":"366474f0","chunk-5e70a546":"6823257f","chunk-8707e908":"a38e5aaf","chunk-8f516e26":"a7046c0b","chunk-a5c1f194":"2008d1d0","chunk-0e7753bf":"468d721c","chunk-1f832b0f":"7999f07f","chunk-a7543ca6":"3756ade1","chunk-c3c8c8bc":"d99bb274","chunk-d7a826f4":"a62fe16f","chunk-711a83b6":"96b7f5e0","chunk-f3f79a2a":"6616ea52","chunk-bd23fad0":"1950a6f5","chunk-3377a62a":"57493e00","chunk-2d0bdd64":"31d6cfe0","chunk-4e24537e":"0ac9f6b3","chunk-3b57d365":"c13899c2","chunk-361c9c0a":"55a54323","chunk-67355449":"bb11871b","chunk-9332d9aa":"0616bd83","chunk-9475d680":"9df18fb1","chunk-a74b9602":"31e220b9","chunk-dc51ebe2":"99b9e946","chunk-e58aaa66":"b5d184fb","chunk-fdd8e336":"225e5edd","chunk-06da49da":"31e1088a","chunk-1e90db16":"abb1d226","chunk-493027cc":"389495c7","chunk-cf67f430":"fb6a0ffb","chunk-052f9ba4":"44133923","chunk-7aa3c928":"104b8bda","chunk-2457ad77":"c3b6f6a0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://sokogate.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["chunk-dbb8d16a","chunk-2d0c5046","chunk-165170c0","chunk-0891119c","chunk-308a9a57","chunk-31129060","chunk-a7543ca6","chunk-54441e99","chunk-51c35f17","chunk-3377a62a","chunk-4e24537e","chunk-2d0bdd64","chunk-109f4ac8","chunk-5c354cbe","chunk-fdd8e336","chunk-955104b2","chunk-0e3ada36","chunk-124253f6","chunk-dc51ebe2","chunk-7e4eac9a","chunk-6f8dca74","chunk-1c8776c6"]]);
 	return startupResult;
